import { BetSlipType } from "app/types/betSlipType";
import { RunnerAggregatedPriceType } from "app/types/eventType";
import { ExchangeRunnerPriceSides } from "app/utils/const";

export class ExchangeHelper {
  // create exchange array with 6 blank prices
  // then populate with existing prices in the approprite place
  static compileExchangePrices = (
    aggregatedPrices: RunnerAggregatedPriceType[]
  ) => {
    // Assuming aggregatedPrices is an array of RunnerAggregatedPriceType
    if (aggregatedPrices === undefined) return;
    const backPrices = aggregatedPrices.filter(
      price => price.side === ExchangeRunnerPriceSides.BACK
    );
    const layPrices = aggregatedPrices.filter(
      price => price.side === ExchangeRunnerPriceSides.LAY
    );
    // Function to create a blank cell with default values
    const blankCells: RunnerAggregatedPriceType[] = Array.from(
      { length: 6 },
      () => ({
        odds: 0,
        decimalOdds: 0,
        availableAmount: 0,
        displayOdds: 0,
        sourceName: "",
        sourceOdds: 0,
        sourceAvailableAmount: 0,
        oddsType: "",
        side: ExchangeRunnerPriceSides.BLANK,
      })
    );
    // populate blankCells object with available back prices
    let backIndex = 2;
    backPrices.map((backPrice: RunnerAggregatedPriceType) => {
      blankCells[backIndex] = backPrice;
      backIndex--;
    });
    // populate blankCells object with available lay prices
    let layIndex = 3;
    layPrices.reverse().map((layPrice: RunnerAggregatedPriceType) => {
      blankCells[layIndex] = layPrice;
      layIndex++;
    });

    return blankCells;
  };

  static displayExchangeSubheaderText = (side: string) => {
    switch (side) {
      case ExchangeRunnerPriceSides.BACK:
        return "exchange-back-for";
      case ExchangeRunnerPriceSides.LAY:
        return "exchange-back-lay";
      default:
        return "";
    }
  };

  static displayExchangeSide = (betSlip: BetSlipType) => {
    let exchangeSide = betSlip.exchangePrice?.side;
    switch (exchangeSide) {
      case ExchangeRunnerPriceSides.BACK:
        return "exchange-side-back-brackets";
      case ExchangeRunnerPriceSides.LAY:
        return "exchange-side-lay-brackets";
      default:
        return "";
    }
  };
}
